"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const common_1 = require("@components/common");
const styled_components_1 = __importDefault(require("styled-components"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const test_1 = __importDefault(require("@app/routes/SyllabicStructure/test"));
const Description = styled_components_1.default.div `
  font-family: "GolosTextWebRegular", sans-serif;
  color: #6e77fb;
  font-size: 18px;
  padding: 15px;
  text-align: center;
  line-height: 27px;
  font-weight: 500;
  white-space: break-spaces;
  text-transform: uppercase;
`;
const SyllabicStructure = () => {
    const [description, setDescription] = (0, react_1.useState)('');
    const [open, setOpen] = (0, react_1.useState)(true);
    const langId = js_cookie_1.default.get("lang_id");
    (0, react_1.useEffect)(() => {
        const rootElement = document.getElementById('ezspeech-react-front');
        const shortDescription = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.getAttribute('data-exercise-name')) || '';
        setDescription(shortDescription);
    }, []);
    (0, react_1.useEffect)(() => {
        if (open) {
            const handleClickOutside = () => setOpen(false);
            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }
    }, [open, setOpen]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.PopUp, { title: `${Number(langId) === 1 ? "Слоговая структура" : "Syllabic structure"}`, onClose: () => setOpen(false), open: open, isUseStopPropogation: false },
            react_1.default.createElement(Description, null, description)),
        react_1.default.createElement(test_1.default, { response: {}, description: description, langId: langId })));
};
exports.default = SyllabicStructure;
